export const validateConfig = (config) => {
    const requiredKeys = [
        "CLIENT_ID",
        "COGNITO_DOMAIN",
        "HTTP_ACCEPT",
        "CATEGORIZER_MODEL"
    ];

    return requiredKeys.every((key) => {
        const value = config[key];
        return value !== undefined && value !== null && value !== "";
    });
}
